// extracted by mini-css-extract-plugin
module.exports = {"raceDetailsContainer":"_63d0666"};